export default function passesKeywordsFilter(item, filter, searchFields) {
    // If no keyword supplied, then the item passes without question
    if (!filter.values.length || !filter.values[0]) { return true; }

    // For each field specified in the strings array, build a string to search through - if not specified we search the title and excerpt
    const stringFields = (searchFields && searchFields.length) ? searchFields : ['title', 'excerpt'];
    let searchString = '';

    stringFields.forEach(field => {
        // Handle arrays differently
        if (Array.isArray(item[field])) {
            searchString += item[field].join(' ').toLowerCase();
        } else {
            searchString += `${item[field]} `.toLowerCase();
        }
    });

    // Return the item if the string matches our input
    return searchString.indexOf(filter.values[0].toLowerCase()) !== -1;
}



// WEBPACK FOOTER //
// ./src/components/filtered-listing/utils/filters/keywords.js